export default __webpack_public_path__ + "static/media/logo.055c0208.png";